import { Commit } from 'vuex';
import { DemandeDevisState } from './state';

export enum DemandeDevisActions {
    GET_DEMANDES_DEVIS = 'GET_DEMANDES_DEVIS',
    GET_ATTACHMENT = 'GET_ATTACHMENT',
    GET_XLS_DEMANDE_DEVIS = 'GET_XLS_DEMANDE_DEVIS',
    GET_PJ_TO_EDIT = 'GET_PJ_TO_EDIT',
}

export interface DemandeDevisActionTypes {
    commit: Commit;
    state: DemandeDevisState;
    getters: any;
}
